'use strict';

const Enum = require('./enum');

exports.CameraRoutes = Object.create(Enum, {
  sendOne: {
    value: identifier => `hydra.${identifier}.send.one`,
  },
  sendMulti: {
    value: identifier => `hydra.${identifier}.send.multicast`,
  },
  sendAll: {
    value: identifier => `hydra.${identifier}.send.all`,
  },
  BROADCAST: { value: 'hydra.broadcast', enumerable: true },

  // Route is designed to inform hydra-tcp that a hydra is offline due to
  // timeouts.  This is to cover the case of a tcp disconnect
  // that is not detected by hydra-tcp (happens if you yank the battery when it is in standby)
  offline: {
    value: identifier => `hydra.${identifier}.delete`,
  },
});

/**
 * Defines identifiers to distinguish between
 * camera versions.
 *
 * @enum
 * @readonly
 */
exports.CameraVersions = Object.create(Enum, {
  HYDRA: { value: 'hydra', enumerable: true },
  UNKNOWN: { value: 'unknown', enumerable: true },
  parseType: {
    value: function (cameraType) {
      switch (cameraType) {
        case 1:
          return this.HYDRA;
        default:
          return this.UNKNOWN;
      }
    },
    enumerable: false,
  },
  toType: {
    value: function (cameraVersion) {
      switch (cameraVersion) {
        case this.HYDRA:
          return 1;
        default:
          return -1; // unknown
      }
    },
    enumerable: false,
  },
});

/**
 * Defines camera messages.
 * @type {Enum}
 */
exports.CameraMessages = Object.create(Enum, {
  DEVICE_LOGIN: { value: 0x00020001, enumerable: true },
  DEVICE_LOGOUT: { value: 0x00020002, enumerable: true },
  DEVICE_STANDBY: { value: 0x00020009, enumerable: true },
  DEVICE_WAKEUP: { value: 0x0002000b, enumerable: true },
  DEVICE_KEEP_ALIVE: { value: 0x00020010, enumerable: true },
});

/**
 * Defines camera statuses.
 *
 * @enum
 * @readonly
 */
exports.CameraStatuses = Object.create(Enum, {
  ONLINE: { value: 'online', enumerable: true },
  OFFLINE: { value: 'offline', enumerable: true },
  STANDBY: { value: 'standby', enumerable: true },
  WAKING_UP: { value: 'wakingup', enumerable: true },
  UNKNOWN: { value: 'unknown', enumerable: true },
  GOING_TO_SLEEP: { value: 'goingToSleep', enumerable: true },
});

/**
 * Defines camera modes.
 *
 * @enum
 * @readonly
 */
exports.CameraModes = Object.create(Enum, {
  INVALID: { value: 'invalid', enumerable: true },
  RECORDING: { value: 'recording', enumerable: true },
  STREAMING: { value: 'streaming', enumerable: true },
  STANDBY: { value: 'standby', enumerable: true },
  UNKNOWN: { value: 'unknown', enumerable: true },
});
